import React from 'react'
import { Line } from 'react-chartjs-2'
import { Col, Row, Typography } from 'antd'

const { Title } = Typography

const LineChart = ({ coinHistory, currentPrice, coinName }) => {
    const coinPrice = []
    const coinTimestamp = []

    // coinHistory?.data?.history.forEach(element => {
    //     coinPrice.push(element.price)
    //     coinTimestamp.push(new Date(element.timestamp).toLocaleDateString())
    // });

    for (let i = 0; i < coinHistory?.data?.history?.length; i += 1) {
        coinPrice.push(coinHistory?.data?.history[i]?.price)
        coinTimestamp.push(new Date(coinHistory?.data?.history[i]?.timestamp).toLocaleDateString())
    }

    const data = {
        labels: coinTimestamp,
        datasets: [
            {
                label: 'Price In USD',
                data: coinPrice,
                fill: false,
                backgroundColor: '#0071bd',
                borderColor: '#0071bd',
            },
        ],
    };

    const options = {
        scales: {
            yAxes: [
                {
                    ticks: {
                        beginAtZero: true,
                    },
                },
            ],
        },
    };

    if (!coinHistory) return 'Loading...'
    if (!coinName) return 'Loading...'
    if (!currentPrice) return 'Loading...'

    console.log(coinPrice, coinTimestamp)
    console.log(coinHistory?.data?.history)

    return (
        <>
            <Row className='chart-header'>
                <Title level={2} className='chart-title'>{coinName} Price Chart</Title>
                <Col className='price-container'>
                    <Title level={5} className='price-change'>{coinHistory?.data?.change}%</Title>
                    <Title level={5} className='current-price'>Current {coinName} Price: ${currentPrice}</Title>
                </Col>
                <Line data={data} option={options} />
            </Row>
        </>
    )
}

export default LineChart